import axios from '../axios'
import store from '../store/store'

export default class CustomerService {

  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------After lazy loading--------------------
  // ----------------------------------------------
  // ----------------------------------------------

  
  
  getEnquiryCustomerMBPbranches(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getEnquiryCustomerMBPbranches/' + customerId
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteMBPDepartment(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/mbpdepts/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editMBPDepartment(mbpDepartment) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!mbpDepartment.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/mbpdept/' + mbpDepartment.id
          
          var response = await axios.put(path, mbpDepartment)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveMBPDepartment(mbpDepartment) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/mbpdept'
        
        var response = await axios.post(path, mbpDepartment)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllMBPDepartmentsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/mbpdepts'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/mbpDepartments`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllMBPDepartments() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/mbpDepartments`]) {
        resolve(store.getters[`commons/mbpDepartments`])
  
      } else {
        try {
          var path = '/v1/mbpdepts'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/mbpDepartments`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }

  deleteJobFunction(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/jobFunction/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editJobFunction(jobFunction) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!jobFunction.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/jobFunction/' + jobFunction.id
          
          var response = await axios.put(path, jobFunction)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveJobFunction(jobFunction) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/jobFunction'
        
        var response = await axios.post(path, jobFunction)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllJobFunctionsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/jobfunctions'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/jobfunctions`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllJobFunctions() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/jobfunctions`]) {
        resolve(store.getters[`commons/jobfunctions`])
  
      } else {
        try {
          var path = '/v1/jobfunctions'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/jobfunctions`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }

  saveCustomerGroupAccount(customerId, account) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/addCustomerMBPBranch/' + customerId
        
        var response = await axios.post(path, account)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerGroups(customerId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/customergroup/' + customerId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteCityTown(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/cityTown/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editCityTown(cityTown) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!cityTown.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/cityTown/' + cityTown.id
          
          var response = await axios.put(path, cityTown)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveCityTown(cityTown) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/cityTown'
        
        var response = await axios.post(path, cityTown)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllActiveCitiesTownsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeCitiesTowns'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeCitiesTowns`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllActiveCitiesTowns() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeCitiesTowns`]) {
        resolve(store.getters[`commons/activeCitiesTowns`])
  
      } else {
        try {
          var path = '/v1/activeCitiesTowns'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeCitiesTowns`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }
  
  getAllCitiesTownsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/citiesTowns'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/citiesTowns`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllCitiesTowns() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/citiesTowns`]) {
        resolve(store.getters[`commons/citiesTowns`])
  
      } else {
        try {
          var path = '/v1/citiesTowns'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/citiesTowns`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }
  
  mergeCustomer(fromCustomerId, toCustomerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/mergeCustomer/' + fromCustomerId + '/' + toCustomerId
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  assignCustomer(oldCustomerId, newCustomerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/assignNewCustomer/' + oldCustomerId + '/' + newCustomerId
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerApprovalsFilterByPage(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/approvecustomerfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomers2(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerfilterbypage2/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomers(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomersFromSource(filterId, page, rows, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  applyCustomersQuickFilterByPage(filterId, page, rows, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerquickquery/' + filterId + '/' + page + '/' +  rows
        var response = await axios.post(path, body)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getSavedFilteredCustomersByPage(filterId, page, rows) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/savedFilteredCustomersbypage/' + filterId + '/' + page + '/' +  rows
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllCustomersByPage(page, rows) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customers/page/' + page + '/' +  rows
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerCount() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customers/count'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }


  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------Before Lazy loading-------------------
  // ----------------------------------------------
  // ----------------------------------------------
  


  removeLink(customerId, branchId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/removeCustomerMBPBranches/' + customerId + '/' + branchId
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }  

  setCustMBPBranchActive(customerId, value) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setCustMBPBranchActive/' + customerId + '/' + value
        var response = await axios.put(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  setCustMBPBranchInactive(customerId, branchId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setCustMBPBranchInactive/' + customerId + '/' + branchId
        var response = await axios.post(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  addCustomerMBPBranch(customerId, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/addCustomerMBPBranch/' + customerId
        var response = await axios.post(path, body)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  assignedCustomerMBPbranches(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/assignedCustomerMBPbranches/' + customerId
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteCustomer(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customers/' + customerId
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerApprovals() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/custreqapproval'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerStats(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = 'v1/salesStat/' + customerId
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  getCustomerSummaryStats(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = 'v1/last5yrsSalesStat/' + customerId
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerHistory(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getCustomerHistory/' + customerId
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerNamesByRegion(regionId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customernamesbyregion/' + regionId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  checkTASCode(TASCode, branchId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/checkCustCode/' + TASCode + '/' + branchId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  checkCustCode(custCode, branchId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/checkCustCodeExist'
        
        var response = await axios.post(path, { custCode, branchId })
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getCustomerRegion(postCode) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerRegionSalesexec/' + postCode
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  customerGlobalSearch(text) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerGlobalSearch/' + text
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  customersCustomSearchURL(pathParams, searchText) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/searchCustomers/' + pathParams
        
        var response = await axios.post(path, { searchText })
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  searchCustomers(text) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/searchedcustomer/' + text
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  //MBP

  setCustomerToActive(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setCustomersActive/' + customerId
        
        var response = await axios.put(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  setCustomerToInactive(customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setCustomersInactive/' + customerId
        
        var response = await axios.put(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDupCustomers(body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/checkDupCustomers'
        
        var response = await axios.post(path, body)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllCustomers() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customers'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getParentCustomers() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/parentcustomernames`]) {
        resolve(store.getters[`commons/parentcustomernames`])
  
      } else {
        try {
          var path = '/v1/parentcustomernames'
          
          var response = await axios.get(path)
          // 
          try {
            store.dispatch(`commons/parentcustomernames`, response.data)
          } catch(e) {}
          
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getCustomerActivities(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customeractivities/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getCustomerQuotations(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerquotes/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveCustomers() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activecustomers'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerNames() {
    return new Promise(async function(resolve, reject) {
      if (
        store.getters[`commons/customernames`]
        && store.getters[`commons/customernames`].length
      ) {
        resolve(store.getters[`commons/customernames`]) 
  
      } else {
        try {
          var path = '/v1/customernames'
          
          var response = await axios.get(path)
          // 
          try {
            store.dispatch(`commons/customernames`, response.data)
          } catch(e) {}
          
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getCustomerInfo(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerInfo/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getLinkedCustomerAccounts(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customergroup/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerContacts(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerContacts/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveCustomerContacts(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeCustomerContacts/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerNotes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/allcustomernotes/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getCustomerAttachment(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/onlyCustomerAttachments/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDefCustomersFilter(userId) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/defcustomersfilter/' + userId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getSavedFilteredCustomers(filterId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/savedFilteredCustomers/' + filterId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveCustomer(customer) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customer'
        
        var response = await axios.post(path, customer)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  saveDuplicateCustomer(customer) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customerconf'
        
        var response = await axios.post(path, customer)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  updateCustomer(id, customer) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customers/' + id
        
        var response = await axios.put(path, customer)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  updateCustomerContact(id, customerId) {
    return new Promise(async function(resolve, reject) {
      try {
        let customer = {
          keyContact: customerId
        }
        
        var path = '/v1/customers/' + id
        
        var response = await axios.put(path, customer)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveCustomerTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeCustomerTypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activecustomertypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveCustomerTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activecustomertypes`]) {
        resolve(store.getters[`commons/activecustomertypes`])
  
      } else {
        try {
          var path = '/v1/activeCustomerTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activecustomertypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  // Get all Customer LOV Data

  getAllCustomerTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customertypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/customertypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllCustomerTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/customertypes`]) {
        resolve(store.getters[`commons/customertypes`])
  
      } else {
        try {
          var path = '/v1/customertypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/customertypes`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  postCustomerTypes(customerTypes) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customertypes'
        
        var response = await axios.post(path, customerTypes)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putCustomerTypes(customerTypes, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customertypes/' + id
        
        var response = await axios.put(path, customerTypes)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteCustomerTypes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customertypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveIndustryTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeIndustryTypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllIndustryTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/industrytypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  postIndustryType(industryType) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/industrytypes'
        
        var response = await axios.post(path, industryType)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putIndustryType(industryType, id) {
    return new Promise(async function(resolve, reject) {
      try {
      var path = '/v1/industrytypes/' + id
        
        var response = await axios.put(path, industryType)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteIndustryType(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/industrytypes/' + id
        var config = {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('user-token'),
          }
        };
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveRegionsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeRegions'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeRegions`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveRegions() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeregions`]) {
        resolve(store.getters[`commons/activeregions`])
  
      } else {
        try {
          var path = '/v1/activeRegions'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activeregions`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getAllRegionsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/regions'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/regions`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllRegions() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/regions`]) {
        resolve(store.getters[`commons/regions`])
  
      } else {
        try {
          var path = '/v1/regions'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/regions`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  postRegions(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/regions'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putRegions(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/regions/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteRegions(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/regions/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActivePostalAreas() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activePostalAreas'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllPostalAreas() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/postalAreas'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  postPostalArea(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/postalAreas'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putPostalArea(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/postalAreas/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deletePostalArea(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/postalAreas/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveMBPBranches() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activembpbranches`]) {
        resolve(store.getters[`commons/activembpbranches`])
  
      } else {
        try {
          var path = '/v1/activeMbpBranches'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activembpbranches`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getAllMBPBranches() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/mbpbranches`]) {
        resolve(store.getters[`commons/mbpbranches`])
  
      } else {
        try {
          var path = '/v1/mbpBranches'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/mbpbranches`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  getCustomerMBPranches(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customerMBPbranches/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveSalesExecsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeSalesExecs'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeSalesExecs`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActiveSalesExecs() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activesalesexecs`]) {
        resolve(store.getters[`commons/activesalesexecs`])
  
      } else {
        try {
          var path = '/v1/activeSalesExecs'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activesalesexecs`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getAllSalesExecsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salesExecs'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/salesexecs`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllSalesExecs() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/salesexecs`]) {
        resolve(store.getters[`commons/salesexecs`])
  
      } else {
        try {
          var path = '/v1/salesExecs'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/salesexecs`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  postSalesExec(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salesExecs'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putSalesExec(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salesExecs/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteSalesExec(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salesExecs/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveContactTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeContactTypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  // Get all Contact LOV Data
  getAllContactTypes() {
    return new Promise(async function(resolve, reject) {
      //if to add in store, then also for getAllContactTypesByHard
      try {
        var path = '/v1/contacttypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  postContactType(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/contacttypes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putContactType(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/contacttypes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteContactType(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/contacttypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveJobTitlesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeJobTitles'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeJobTitles`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActiveJobTitles() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activejobtitles`]) {
        resolve(store.getters[`commons/activejobtitles`])
  
      } else {
        try {
          var path = '/v1/activeJobTitles'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activejobtitles`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }
  getAllJobTitlesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/jobtitles'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/jobtitles`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllJobTitles() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/jobtitles`]) {
        resolve(store.getters[`commons/jobtitles`])
  
      } else {
        try {
          var path = '/v1/jobtitles'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/jobtitles`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  postJobTitles(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/jobtitles'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putJobTitles(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/jobtitles/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteJobTitles(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/jobtitles' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveSalutationsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activesalutations'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activesalutations`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getActiveSalutations() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activesalutations`]) {
        resolve(store.getters[`commons/activesalutations`])
  
      } else {
        try {
          var path = '/v1/activeSalutations'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activesalutations`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
  
      }
    })

  }
  getSalutationsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salutations'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/salutations`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getSalutations() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/salutations`]) {
        resolve(store.getters[`commons/salutations`])
  
      } else {
        try {
          var path = '/v1/salutations'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/salutations`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
  
      }
    })

  }
  postSalutations(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salutations'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putSalutations(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salutations/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteSalutations(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/salutations/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // CRUD Contact
  saveContactDB(contact) {
    return new Promise(async function (resolve, reject) {
      try {
        
        var path = '/v1/contact/'
        
        var response = await axios.post(path, contact)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // CRUD Contact
  saveDuplicateContactDB(contact) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/contactconf/'
        
        var response = await axios.post(path, contact)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateContactDB(id, contact) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/contact/' + id
        
        var response = await axios.put(path, contact)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // CRUD Notes
  getNote(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/customernote/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveNoteDB(note) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customernotes/'
        
        var response = await axios.post(path, note)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateNoteDB(id, note) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customernotes/' + id
        
        var response = await axios.put(path, note)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteNoteDB(id) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/customernotes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}
